import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 0 8px;
  box-sizing: border-box;
`

export const AddProjectButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-base, #fff);

  cursor: pointer;
`

export const AddProjectIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;

  svg {
    font-size: 16px;
    fill: var(--foreground-neutral, #14171f);
  }
`

export const AddProjectLabel = styled.div`
  color: var(--foreground-neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
